const PLACEHOLDER_REGEX = /\{([a-z0-9_]+)\}/gi;

function interpolateMarkup(template: string, values: Record<string, string>): string {
  return template.replaceAll(PLACEHOLDER_REGEX, (match, key) => values[key] ?? match);
}

export { interpolateMarkup };
